import { render, staticRenderFns } from "./_EmailForm.vue?vue&type=template&id=98d3fbc8&"
import script from "./_EmailForm.vue?vue&type=script&lang=js&"
export * from "./_EmailForm.vue?vue&type=script&lang=js&"
import style0 from "./_EmailForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VFlex,VLayout})
